/**
 * US city seed for the event-location autocomplete. Plain data — the generic
 * `<Autocomplete>` primitive consumes it (the old bespoke `CityAutocomplete`
 * component was removed; it duplicated `<Autocomplete>`'s logic).
 */
export const US_CITIES: ReadonlyArray<string> = [
  "New York, NY", "Los Angeles, CA", "Chicago, IL", "Houston, TX", "Phoenix, AZ",
  "Philadelphia, PA", "San Antonio, TX", "San Diego, CA", "Dallas, TX", "San Jose, CA",
  "Austin, TX", "Jacksonville, FL", "Fort Worth, TX", "Columbus, OH", "Charlotte, NC",
  "San Francisco, CA", "Indianapolis, IN", "Seattle, WA", "Denver, CO", "Washington, DC",
  "Boston, MA", "El Paso, TX", "Nashville, TN", "Detroit, MI", "Oklahoma City, OK",
  "Portland, OR", "Las Vegas, NV", "Memphis, TN", "Louisville, KY", "Baltimore, MD",
  "Milwaukee, WI", "Albuquerque, NM", "Tucson, AZ", "Fresno, CA", "Sacramento, CA",
  "Kansas City, MO", "Mesa, AZ", "Atlanta, GA", "Omaha, NE", "Colorado Springs, CO",
  "Raleigh, NC", "Miami, FL", "Long Beach, CA", "Virginia Beach, VA", "Oakland, CA",
  "Minneapolis, MN", "Tulsa, OK", "Arlington, TX", "New Orleans, LA", "Wichita, KS",
  "Cleveland, OH", "Tampa, FL", "Bakersfield, CA", "Aurora, CO", "Anaheim, CA",
  "Honolulu, HI", "Santa Ana, CA", "Riverside, CA", "Corpus Christi, TX", "Lexington, KY",
  "Portland, ME", "Henderson, NV", "Saint Paul, MN", "St. Louis, MO", "Cincinnati, OH",
  "Pittsburgh, PA", "Greensboro, NC", "Anchorage, AK", "Plano, TX", "Lincoln, NE",
  "Orlando, FL", "Irvine, CA", "Newark, NJ", "Toledo, OH", "Durham, NC",
  "Madison, WI", "Buffalo, NY", "Scottsdale, AZ", "Reno, NV", "Boise, ID",
  "Richmond, VA", "Baton Rouge, LA", "Spokane, WA", "Des Moines, IA", "Tacoma, WA",
  "Brookline, MA", "Cambridge, MA", "Berkeley, CA", "Pasadena, CA", "Santa Monica, CA"
];
